import InnerComponent from '@Components/Inventory/ManageProducts/ViewProduct';
import orgContainer from '@Components/AppContainer';

const ViewProduct = () => ((orgContainer(InnerComponent)));
export default ViewProduct;
